export default __webpack_public_path__ + "static/media/facilitymgmt_bg.e04e64b3.jpeg";